import React, { useState } from 'react';
import useStyles from 'src/Styles';
import PpaContractComponent from './PpaContractComponent';
import { useHistory } from 'react-router-dom';
import { Button, Grid } from '@material-ui/core';
import { trackPromise } from 'react-promise-tracker';
import axios from '../../axios/AxiosInterceptors';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { onError, onSuccess } from 'src/store/actions/popupActions';

const ViewUpdatePpaContract = (props) => {

    const classes = useStyles();
    const history = useHistory();
    const params = useParams();
    const dispatch = useDispatch();
    const ppaContract = useSelector(state => state.ppaContract.ppaContract)

    const savePpaContract = async () => {
        await trackPromise(axios.put("/account-service/v1/account/" + params.accountId + "/generator/" + ppaContract.ppaGenerator.id + "/ppa/" + params.ppaId, JSON.stringify(ppaContract)).then(response => {
            dispatch(onSuccess("Updated PPA Contract"));
            history.push("/ppa-contract/account/" + params.accountId + "/ppa");
        }).catch(error => {
            dispatch(onError(error.response));
        }))
    }

    return (
        <main className={classes.layout}>
            <PpaContractComponent isEdit={true} />
            <Grid container spacing={2}>
                <Grid item xs={6} sm={2} />
                <Grid item align="center" xs={6} sm={3}>
                    <Button onClick={() => history.push("/ppa-contract/account/" + params.accountId + "/ppa")}>Back</Button>
                </Grid>
                <Grid item xs={6} sm={2} />
                <Grid item xs={6} sm={3}>
                    <Button align="center" onClick={savePpaContract}>Save</Button>
                </Grid>
                <Grid item xs={6} sm={2} />
            </Grid>
        </main>
    )

}

export default ViewUpdatePpaContract;